import ApiService from "../../Services/ApiService";

export default {
    state: {
        trades: [],
    },

    getters: {
//        getUserTradesByUserAccounts(state, userAccounts) {
            //TODO... filter on the selected accounts (top-right)
//            return state.trades;
//        },
    },

    mutations: {
    },

    actions: {

    }
};
